import { render } from "./ModalSyncWms.vue?vue&type=template&id=3cb1e9e6"
import script from "./ModalSyncWms.vue?vue&type=script&lang=js"
export * from "./ModalSyncWms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__